import ApiService from "../../utils/fetch";
// const userRolesUrl = `${process.env.REACT_APP_BASE_URL}/user-access/`;
const userRolesUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/user-access/`;
const hostUrl = process.env.REACT_APP_BACKEND_BASE_URL;

export const fetchUserAccess = async () => {
    const url = `${userRolesUrl}fetch-uam-user-details`;
    const response = await ApiService.get(url)
    return response.data;
}

export const fetchRegionsAndPlants = async (applicationType) => {
    const url = `${userRolesUrl}fetchAllPlants?applicationType=${encodeURIComponent(applicationType || "")}`;
    const response = await ApiService.get(url);
    return response.data;
}

export const fetchMrpControllers = async (mrpPlants) => {
    const url = `${userRolesUrl}fetchMrpController`
    const payload = { mrpPlants };
    const response = await ApiService.post(url, payload);
    return response.data;
}

/**
 * Raise an access request for a user.
 * @param {object} payload - The request payload.
 * @param {string} applicationType - The application type (e.g., 'Command Center', 'IO - Safety Stock Approval').
 */
export const raiseAccessRequest = async (payload, applicationType) => {
    if (applicationType === 'IO - Safety Stock Approval') {
        const url = `${userRolesUrl}raise-ss-access-request`;
        const response = await ApiService.post(url, payload);
        return response.data;
    }

    if (
        applicationType !== 'IO - Safety Stock Approval' &&
        applicationType !== 'Command Center'
    ) {
        const url = `${userRolesUrl}raise-access-request`;
        const response = await ApiService.post(url, payload);
        return response.data;
    }

    if (applicationType === 'Command Center') {
        const primaryUrl = `${userRolesUrl}raiseCT-access-request`;
        try {
            const response = await ApiService.post(primaryUrl, payload);
            return response.data;
        } catch (error) {
            // Some backend environments expose kebab-case endpoint.
            if (error?.response?.status === 404) {
                const fallbackUrl = `${userRolesUrl}raise-ct-access-request`;
                const fallbackResponse = await ApiService.post(fallbackUrl, payload);
                return fallbackResponse.data;
            }
            throw error;
        }
    }

    throw new Error(`Unsupported application type: ${applicationType}`);
}

export const raiseAccessRequestForUsers = async (payload) => {
    const url = `${userRolesUrl}raise-access-request-for-users`;
    const response = await ApiService.post(url, payload);
    return response.data;
}

export const fetchTeamsAndRoles = async () => {
    const url = `${userRolesUrl}teamsAndRoles`;
    const response = await ApiService.get(url);
    return response.data;
}

export const searchUserName = async (searchText) => {
    const url = `${userRolesUrl}adgroup/members?searchText=${encodeURIComponent(searchText)}`;
    const response = await ApiService.get(url);
    return response.data;
}

export const fetchBottlingGroups = async (regions, plants) => {
    const url = `truck-optimisation/bottling-groups?regions=${regions.join(",")}&plants=${plants.join(",")}`;
    const response = await ApiService.get(url);
    return response.data;
};

export const raiseSopAccessRequest = async (payload) => {
    const url = `${userRolesUrl}raise-sop-access-request`;
    const response = await ApiService.post(url, payload);
    return response.data;
};

export const fetchAllAdminApprovals = async (adGroup = '') => {
    const adminApprovalBaseUrl = `${hostUrl}/admin-approval/`;
    const url = `${adminApprovalBaseUrl}fetchAllRecords${adGroup ? `?adGroup=${encodeURIComponent(adGroup)}` : ''}`;
    const response = await ApiService.get(url);
    return response.data;
};

export const deleteAdminApprovalRecord = async (ids) => {
    // Format IDs into a comma-separated string if passed as an array
    const formattedIds = Array.isArray(ids) ? ids.join(',') : ids;
    const url = `${hostUrl}/admin-approval/deleteRecord/${encodeURIComponent(formattedIds)}`;
    const response = await ApiService.delete(url);
    return response.data;
};

export const insertAdminApprovalRecord = async (payload) => {
    const url = `${hostUrl}/admin-approval/insertRecord`;

    try {
        const response = await ApiService.post(url, payload, { skipGlobaloast: true });
        return response.data;
    } catch (error) {
        const errorMessage =
            error?.response?.data?.message ||
            `Duplicate or invalid configuration for ${error.ownerEmail}`;
        throw new Error(errorMessage);
    }
};

export const fetchAdminAccessRecords = async () => {
    const url = `${userRolesUrl}admin-access`;
    const response = await ApiService.get(url);
    return response.data;
};

export const createAdminAccessRecord = async (payload) => {
    const url = `${userRolesUrl}admin-access`;
    const response = await ApiService.post(url, payload);
    return response.data;
};

export const deleteAdminAccessRecord = async (id) => {
    try {
        const response = await ApiService.delete(`${userRolesUrl}admin-access/${id}`);
        return response.status === 204 || response.status === 200;
    } catch (error) {
        console.error(`Failed to delete admin access record with ID: ${id}`, error);
        throw error;
    }
};
export const fetchAdminList = async () => {
    const url = `${hostUrl}/admin-approval/fetchAdminList`;

    const response = await ApiService.get(url);
    // Returns response.data which contains array or wrapped data object
    return response.data;
};

export const updateAdminAccessRecord = async (id, payload) => {
    const url = `${userRolesUrl}admin-access/${id}`;
    const response = await ApiService.put(url, payload);
    return response.data;
};
